// extracted by mini-css-extract-plugin
export default {"container":"styles_container__aUIsq","title":"styles_title__X7F6i","loginTypes":"styles_loginTypes__VGFnu","typeIcon":"styles_typeIcon__OGEFc"};